import { IMG_HOSTING } from './domain';

// 上传地址 https://image-tools.mytestdrama.com/index.html

export const IMG_HOSTING_URLS = {
    WALLET_CARD_BG: `${IMG_HOSTING}1679940ee99ea515bf047d8501c67876.png`,
    MY_CARD_BG: `${IMG_HOSTING}e7a406620c12082a000bd63a66d6d815.png`,
    COINS_28: `${IMG_HOSTING}dcd6669101a8d9d0ac9a18c92809992c.png`,
    COINS_24: `${IMG_HOSTING}3c58ef011abdb2619c16cb611bdaad24.png`,
    COINS_20: `${IMG_HOSTING}4c55cd4da1cf90074deaf703d9cdcfcd.png`,
    BONUS_28: `${IMG_HOSTING}aaaf167eff7812473e739a7f55ebd8c9.png`,
    BONUS_24: `${IMG_HOSTING}b6ff56a4e6a2fd888a9bb49ff41af163.png`,
    BONUS_20: `${IMG_HOSTING}afa3d33fc27627a7b96eb05d2e42c558.png`,
    VIP_20: `${IMG_HOSTING}64ac5d9be230e8025c3acfee9974a66c.png`,
    BONUS_EXPIRED_22: `${IMG_HOSTING}f9ef73a76f800f218b32f9fa289891ff.png`,
    BONUS_LOCK: `${IMG_HOSTING}bbdebfb085704090118da54240075a70.png`,
    CANCEL_PAY_IMG_URL: `${IMG_HOSTING}bbdebfb085704090118da54240075a70.png`,
    PAYPAL_LOADING_LOGO: `${IMG_HOSTING}92046216db770fbf36e25e11c6c35a10.png`,
    PAYPAL_LOADING_SPINNER: `${IMG_HOSTING}ea75768d242ba3c6fe287a7372c42064.svg`,
    EMPTY_PLACEHOLDER: `${IMG_HOSTING}empty-placeholder.png`,
};
